<template>
  <div>
    <NuxtLayout>
      <!-- keepalive 要以路由的形式实现才有效 -->
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
// import UAParser from 'ua-parser-js';

// const parser = new UAParser();
// const router = useRouter();
// const result = parser.getResult();
// if (result.device.type === 'mobile') {
//   // 是移动端，跳转到移动端路由
//   router.push('/m');
// } else {
//   // 是桌面端，跳转到桌面端路由
//   router.push('/');
// }
// This compiler macro works in both <script> and <script setup>
</script>

<style scoped>
/* .bg {
  background: linear-gradient(to bottom right, #D2E3FF, #FEF6FF, #F9F9F9);
} */
</style>
